import styled from "styled-components";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import { faSquare } from "@fortawesome/free-solid-svg-icons";
import { faSquareCaretDown } from "@fortawesome/free-solid-svg-icons";
import { faTriangleCircleSquare } from "@fortawesome/free-solid-svg-icons";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { faArrowTurnRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./CalculatedItems.css";
import { Button } from "components/Button";
import { useForm, Controller } from "react-hook-form";
import { ISumCart } from "components/Cart";
import { Fragment, useContext, useEffect, useState } from "react";
import {
  addItemToCardService,
  downloadCardService,
  fetchCardItemsService,
  fetchCartByIdService,
  handleValuationService,
  updateCardItemService,
} from "services/cart";
import { getCartId } from "utils/getCartId";
import { TextField } from "components/TextField";
import { Typography } from "components/Typography";
import { getUserId } from "utils/getUserId";
import { favoriteService } from "services/favorite";
import { ValuationModal } from "components/ValuationModal";
import { CalculatorContext } from "App";

const List = styled.div`
  position: absolute;
  left: 0px;
  width: 100%;
  height: 100%;
  z-index: 5;
  background-color: #fff;
  top: 0;
`;

const ActionCartBtn = styled.button`
  cursor: pointer;
`;

interface IProps {
  items: any[];
  handleRemove: (id: string) => void;
  handleClear: (id: string) => void;
}

const Pipe = styled.div``;
export const Item = ({ items, handleRemove, handleClear }: IProps) => {
  const [itemWeights, setItemWeights] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const [query, setQuery] = useState({ quantity: 0, id: "" });
  const [sumCart, setSumCart] = useState<ISumCart>({
    sumLength: 0,
    sumWeight: 0,
  });

  const fetchCardById = async () => {
    try {
      setIsLoading(true); // Set loading state to true
      const response = await fetchCartByIdService(getCartId());
      if (response.status === 200) {
        const sum = {
          sumLength: response.data.sumLength,
          sumWeight: response.data.sumWeight,
        };
        setSumCart(sum);
        const updatedItemWeights = {};
        response.data.items.forEach((item) => {
          updatedItemWeights[item.id] = item.weight;
        });
        setItemWeights(updatedItemWeights);
      }
    } finally {
      setIsLoading(false); // Set loading state to false after asynchronous code
    }
  };

  const handleChange = async () => {
    if (!query.id) return;

    setIsLoading(true); // Set loading state to true

    try {
      await updateCardItemService(query.id, {
        quantity: query.quantity,
      });
      fetchCardById();
    } finally {
      setIsLoading(false); // Set loading state to false after asynchronous code
    }
  };

  const handleDownload = async () => {
    const response = await downloadCardService(getCartId());
    if (response.status === 200) {
      const href = response.config.url;
      const link = document.createElement("a");
      link.href = href;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setIsSubmitted(false);
  };

  const handleValuation = async (formData: any) => {
    const response = await handleValuationService(getCartId(), formData);
    if (response.status === 200) {
      console.log(response.data);
    }
  };

  useEffect(() => {
    fetchCardById();
  }, [items]);

  useEffect(() => {
    const timeOutId = setTimeout(() => {
      handleChange();
    }, 500);
    return () => clearTimeout(timeOutId);
  }, [query.id, query.quantity]);

  const handleQuantityChange = (itemId: string, newQuantity: number) => {
    setQuery({ quantity: newQuantity, id: itemId });
    fetchCardById();
  };

  useEffect(() => {
    fetchCardById();
  }, [items]);

  const context = useContext(CalculatorContext);

  const { translations } = context!;

  return (
    <>
      <List className="calculated-items-container">
        <h2>{translations["item-list"]}</h2>
        <table>
          <thead>
            <tr>
              <th className="col">{translations["item-position"]}</th>
              <th className="col">{translations["item-count"]}</th>
              <th className="col">{translations["weight-of-item"]}</th>
              <th className="col">{translations["remove"]}</th>
            </tr>
          </thead>
          <tbody>
            <>
              {items.map((item, index) => {
                return (
                  <tr key={item.id}>
                    <td className="position-name">
                      <b>{index + 1}</b>.{" "}
                      <span>
                        {item.filledFieldList.map((field, index) => (
                          <Fragment key={field.shortName}>
                            {field.value}
                            {index < item.filledFields.length - 1 && <> x </>}
                          </Fragment>
                        ))}
                      </span>
                    </td>
                    <td>
                      <TextField
                        type="number"
                        defaultValue={item.quantity}
                        onChange={(e) =>
                          setQuery({
                            quantity: Number(e.currentTarget.value),
                            id: item.id,
                          })
                        }
                      />
                    </td>
                    <td>{item.weight} kg</td>
                    <td>
                      <FontAwesomeIcon
                        icon={faTimes}
                        onClick={() => handleRemove(item.id)}
                      />
                    </td>
                  </tr>
                );
              })}
            </>
          </tbody>
        </table>
        <hr />
        <div className="list-summary">
          <div>
            <ActionCartBtn onClick={handleClear}>
              {translations["remove-everything"]}
            </ActionCartBtn>
          </div>
          <div className="list-summary-grid">
            <div>{translations["sum-of-items"]}:</div>
            <div>{sumCart.sumWeight.toFixed(1)} kg</div>
            <div>{translations["len-of-items"]}:</div>
            <div>{sumCart.sumLength.toFixed(1)} m</div>
          </div>
        </div>
        <div className="list-summary-btns">
          <Button variant="primary" onClick={handleDownload}>
            {translations["get-the-list"]}
          </Button>

          <button className="btn-send" onClick={openModal}>
            {translations["send-for-quote"]}
          </button>
        </div>
      </List>
      <ValuationModal
        isOpen={isModalOpen}
        handleValuation={handleValuation}
        handleClose={closeModal}
      />
    </>
  );
};
